import { useMediaQuery as useBaseMediaQuery } from 'usehooks-ts';

import { BREAKPOINTS } from '@/constants/breakpoints';

export const useMediaQuery = (query: keyof typeof BREAKPOINTS) => {
  return useBaseMediaQuery(`(max-width: ${BREAKPOINTS[query]})`);
};
